import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquareDot } from "lucide-react";
import { Bell } from "lucide-react";
import { TvMinimal } from "lucide-react";

function Leftbar() {
  const [selected, setSelected] = useState("Notification");

  return (
    <div
      style={{
        width: "187px",
        height: "691px",
        borderRadius: "5px",
        border: "0px, 1px, 0px, 0px",
        padding: "7px",
        gap: "5px",
      }}
      className="inline-flex flex-col justify-start items-start bg-white"
    >
      <Link
        to="/"
        style={{
          borderRadius: "5px",
          padding: "10px",
          gap: "10px",
          border: "0px 0px 0px 2px",
          borderLeft: "2px solid #FEC601",
          fontFamily: "Roboto, sans-serif",
          fontSize: "15px",
          fontWeight: "500",
          lineHeight: "17.58px",
          backgroundColor: selected === "Notification" ? "#FEC60136" : "",
          cursor: selected === "Notification" ? "default" : "pointer",
        }}
        className={`text-left flex items-center h-auto w-full`}
        onClick={() => {
          setSelected("Notification");
        }}
      >
        <MessageSquareDot style={{ width: "20px", height: "20px" }} />
        <p className="px-2">Notification</p>
      </Link>
      <Link
        to="/alert"
        style={{
          borderRadius: "5px",
          padding: "10px",
          gap: "10px",
          border: "0px 0px 0px 2px",
          borderLeft: "2px solid #FEC601",
          fontFamily: "Roboto, sans-serif",
          fontSize: "15px",
          fontWeight: "500",
          lineHeight: "17.58px",
          backgroundColor: selected === "Alert" ? "#FEC60136" : "",
          cursor: selected === "Alert" ? "default" : "pointer",
        }}
        className={`text-left flex items-center h-auto w-full`}
        onClick={() => {
          setSelected("Alert");
        }}
      >
        <Bell style={{ width: "20px", height: "20px" }} />
        <p className="px-2">Alert</p>
      </Link>
      <Link
        to="/connectivity"
        style={{
          borderRadius: "5px",
          padding: "10px",
          gap: "10px",
          border: "0px 0px 0px 2px",
          borderLeft: "2px solid #FEC601",
          fontFamily: "Roboto, sans-serif",
          fontSize: "15px",
          fontWeight: "500",
          lineHeight: "17.58px",
          backgroundColor: selected === "Connectivity" ? "#FEC60136" : "",
          cursor: selected === "Connectivity" ? "default" : "pointer",
        }}
        className={`text-left flex items-center h-auto w-full`}
        onClick={() => {
          setSelected("Connectivity");
        }}
      >
        <TvMinimal style={{ width: "20px", height: "20px" }} />
        <p className="px-2">Connectivity</p>
      </Link>
    </div>
  );
}

export default Leftbar;
